export const menus = [
    // {
    //     id: 1014,
    //     title: "Menu",
    //     route_name: 'menu',
    //     icon: "fas fa-ellipsis-h",
    // },

    // {
    //     id: 1041,
    //     title: "Kateqoriyalar",
    //     route_name: 'category',
    //     icon: "fas fa-list",
    // },

    // {
    //     id: 1092,
    //     title: "Rollar",
    //     route_name: 'roles',
    //     icon: "fas fa-user-check",
    // },
    // {
    //     id: 1094,
    //     title: "Istifadəçilər",
    //     route_name: 'users',
    //     icon: "fas fa-users",
    // },
    {
        id: 100,
        title: "Əsas səhifə",
        name: "main_pages",
        icon: "fas fa-home",
        collapsed: true,
        visible: true,
        items: [
            {
                id: 101,
                title: "Dashboard",
                route_name: 'dashboard',
                icon: "fas fa-th",
                // link: "/dashboard",
            },
            {
                id: 102,
                title: "Dashboard 2",
                route_name: 'dashboard2',
                icon: "fas fa-th",
                // link: "/dashboard",
            },


            {
                id: 104,
                title: "-",
                role: "user",
            },

            {
                id: 105,
                title: "Menu",
                route_name: 'menu',
                icon: "fas fa-ellipsis-h",
                // link: "/menu",
            },
            {
                id: 106,
                title: "Banner",
                route_name: 'banner',
                icon: "fas fa-chalkboard",
                // link: "/products",
            },
            {
                id: 107,
                title: "Statistika",
                route_name: 'statistics',
                icon: "far fa-chart-bar",
                // link: "/products",
            },
            {
                id: 108,
                title: "Kateqoriya",
                route_name: 'category',
                icon: "fas fa-th-list",
                // link: "/category",
            },
            {
                id: 109,
                title: "Bilirsinizmi",
                route_name: 'doyouknow',
                icon: "far fa-question-circle",
                // link: "/category",
            },
            {
                id: 111,
                title: "Məhsullar",
                route_name: 'products',
                icon: "fas fa-list",
                // link: "/products",
            },
        ]
    },
    {
        id: 150,
        title: "Sistem",
        name: "system",
        icon: "fas fa-user-cog",
        collapsed: true,
        visible: true,
        items: [
            {
                id: 151,
                title: "Filter qrupu",
                route_name: 'filter',
                icon: "fas fa-filter",
                // link: "/manufacturer",
            },
            // {
            //     id: 152,
            //     title: "İstehsalçı",
            //     route_name: 'manufacturer',
            //     icon: "fas fa-industry",
            //     // link: "/manufacturer",
            // },

            {
                id: 155,
                title: "-",
                // role: "user",
            },

            {
                id: 156,
                title: "Rollar",
                route_name: 'roles',
                icon: "fas fa-user-check",
                // link: "/role",
            },
            {
                id: 157,
                title: "Istifadəçilər",
                route_name: 'users',
                icon: "fas fa-users",
                // link: "/user",
            },
    //     ]
    // },
    // {
    //     id: 200,
    //     title: 'Sazlama',
    //     icon: 'fas fa-cogs',
    //     collapsed: true,
    //     visible: true,
    //     items: [
            {
                id: 201,
                title: "Dil",
                route_name: 'lang',
                name: 'terms',
                icon: "fas fa-language",
                // link: "/language",
            },
            {
                id: 202,
                title: "Dillər",
                route_name: 'langs',
                name: 'languages',
                icon: "fas fa-language",
                // link: "/language",
            },
            {
                id: 203,
                title: "Sistem",
                route_name: 'settings',
                icon: "fas fa-cog",
                // link: "/system",
            },
        ],
    },
    {
        id: 250,
        title: "Məlumat",
        name: "info",
        icon: "fas fa-info-circle",
        collapsed: true,
        visible: true,
        items: [
            {
                id: 251,
                title: "Profilim",
                route_name: 'profile',
                icon: "fas fa-user",
                // link: "/profile",
            },
            {
                id: 252,
                title: "About",
                route_name: 'about',
                icon: "fas fa-info-circle",
                // link: "/about",
            },
        ]
    }
];
